/** @owner @Appboy/ai-decisioning-experience */

import { createContext } from "react";

import type { DecisioningCreativeComponentLiquidContextStruct } from "../types";
import { defaultDecisioningCreativeComponentLiquidContextStruct } from "./decisioningCreativeComponentLiquidContextConstants";

export const DecisioningCreativeComponentLiquidContext =
  createContext<DecisioningCreativeComponentLiquidContextStruct>(
    defaultDecisioningCreativeComponentLiquidContextStruct
  );
